import defaultChecked from '@ecp/common/src/assets/icon/checkbox--checked.svg';
import defaultDisabled from '@ecp/common/src/assets/icon/checkbox--disabled.svg';
import defaultUnchecked from '@ecp/common/src/assets/icon/checkbox--unchecked.svg';

export const favicon = '/ecp_favicon.ico';

export const color = {
  primary: '#E8651A',
  secondary: '#727272',
  third: '#2D2D2D',
  disabled: '#d3d3d3',
  sub_darkgray: '#3C3C3C',
  sub: '#FFB366',
  fourth: '#D94F0F',
  stroke: '#FF6B35',
  hover: {
    primary: '#FFB366',
    secondary: '#505050',
    third: '#E8651A',
    default: '#eaeaea',
  },
  text: {
    basic: '#2D2D2D',
    basicTab: '#E8651A',
    sub: '#5a5a5a',
    guide: '#727272',
    category: '#9c52ff',
    price: '#FF6B35',
    white: '#ffffff',
    placeholder: '#a3a3a3',
    disabled: '#727272',
    error: '#DC2626',
    event: '#7e9ae3',
    normal: '#7a7a7a',
    mileage: '#FDB022',
    attendance: '#E8651A',
    selected: '#E8651A',
    food: '#fe6f1f',
    best: '#10B981',
    policy: '#E8651A',
    newPlaceholder: '#595959',
  },
  point: {
    basic: '#E8651A',
    negative: '#DC2626',
  },
  line: {
    basic: '#eaeaea',
    background: '#F5DDD1',
    emphasis: '#2D2D2D',
    category: '#9c52ff',
    price: '#FF6B35',
    disabled: '#d3d3d3',
    error: '#DC2626',
    selected: '#7a7a7a',
    sub: '#bdbdbd',
    line02: '#d3d3d3',
  },
  background: {
    basic: '#FFFAF7',
    sub: '#FFFAF7',
    sub1: '#FFFAF7',
    sub2: '#f3f3f3',
    white: '#ffffff',
    disabled: '#d3d3d3',
    gradient: '#FFB366',
    coupon: {
      good: '#FFF3EB',
      cart: '#FFEEE5',
      delivery: '#FFE0D6',
      default: '#5a5a5a',
    },
    arrow: {
      md: '#FFF3EB',
    },
    navigation: '#FFFAF7',
    error: '#FEE2E2',
  },
  icon: {
    default: '#919191',
    current: '#E8651A',
    normal: '#6a6a6a',
    badge: '#F97316',
    benefit: '#FED7AA',
  },
};

export const font = {
  family: "'Noto Sans KR', Arial, Helvetica, sans-serif",
  size: {
    tiny: '10px',
    calendar: '11px',
    error: '12px',
    small: '13px',
    basic: '14px',
    table: '15px',
    label: '16px',
    menu: '17px',
    title: '18px',
    popup: '20px',
    medium: '21px',
    percent: '22px',
    banner: '24px',
    discount: '26px',
    large: '28px',
    hero: '48px',
  },
  weight: {
    demiLight: 300,
    medium: 500,
    medium2: 400,
    bold: 600,
  },
  lineHeight: {
    demiLight: '160%',
    medium: '140%',
    bold: '100%',
  },
  'line-spacing': {},
};

export const image = {
  defaultChecked: defaultChecked,
  defaultDisabled: defaultDisabled,
  defaultUnchecked: defaultUnchecked,
};

export const mobile = {
  numberIndicator: {
    suffixColor: color.text.placeholder,
  },
  footer: {
    contactInfo: {
      borderRadius: '8px',
    },
  },
  myCouponSeeMoreButton: {
    border: `1px solid ${color.line.sub}`,
  },
};

export const component = {
  input: {
    // input border가 border bottom만 있을수 있으므로 통으로집어넣음
    defaultBorder: `border: 1px solid ${color.line.disabled};`,
    disabledBorder: `border: 1px solid ${color.line.disabled};`,
    selectedBorder: `border: 1px solid ${color.primary};`,
    errorBorder: `border: 1px solid ${color.line.error};`,
  },
  button: {
    borderRadius: '8px',
    border: color.text.guide,
    primary: {
      backgroundColor: '#E8651A',
      pressed: {
        color: '#ffffff',
      },
      hover: {
        backgroundColor: '#D94F0F',
      },
      color: '#ffffff',
    },
    secondary: {
      color: '#ffffff',
      border: '',
      backgroundColor: '#727272',
      hover: {
        backgroundColor: '#505050',
      },
      pressed: {
        backgroundColor: '#727272',
      },
    },
    third: {
      backgroundColor: '#2D2D2D',
      pressed: {
        color: '#ffffff',
      },
      hover: {
        backgroundColor: '#E8651A',
      },
      color: '#ffffff',
    },
    default: {
      border: '1px solid #E8651A',
    },
  },
  dropdown: {
    // dropdown border가 border bottom만 있을수 있으므로 통으로집어넣음
    defaultBorder: `border: 1px solid ${color.line.disabled};`,
    fontSize: '13px',
  },
  numberIndicator: {
    border: '1px solid #E8651A',
    borderRadius: '6px',
    background: `${color.background.white}`,
    width: '40px',
    padding: '0 4px',
    button: {
      border: `1px solid #E8651A`,
      borderRadius: '4px',
      background: '#FFFAF7',
    },
  },
  imageFileUploader: {
    borderRadius: '8px',
  },
  swiperMainItem: {
    bannerText1: {
      top: '170px',
    },
    bannerText2: {
      top: '228px',
    },
    bannerText3: {
      top: '336px',
    },
  },
  gnb: {
    logo: {
      marginRight: '147px',
    },
    cart: {
      top: -8,
      right: -8,
    },
  },
  good: {
    selectedOption: {
      borderRadius: '8px',
    },
  },
  order: {
    orderContentHeader: {
      borderBottom: `1px solid ${color.line.background}`,
      paddingBottom: '12px',
    },
    orderContainer: {
      borderRadius: '8px',
    },
    headerContainer: {
      borderTop: '',
      borderRadius: '8px 8px 0 0',
    },
    orderGoodItemInformation: {
      orderContainer: {
        borderTop: `1px solid ${color.line.background}`,
      },
    },
    orderGoodContent: {
      orderGoodList: {
        borderRadius: '0 0 8px 8px',
      },
    },
    payment: {
      agreeTermsConditions: {
        root: {
          borderRadius: '8px',
        },
      },
      orderPaymentTermsAccordion: {
        accordion: {
          borderRadius: '8px',
        },
        flexBox: {
          borderRadius: '8px 8px 0 0',
        },
      },
    },
    cart: {
      optionButton: {
        border: `1px solid ${color.primary}`,
        borderRadius: '8px',
      },
    },
  },
  myPage: {
    myPageOrderPage: {
      periodSearch: {
        borderRadius: '8px',
      },
    },
    myPageOrderList: {
      orderMasterContainer: {
        // 없을 수도 있기때문에 통으로 삽입
        borderTop: `border-top: 1px solid ${color.line.background};`,
        borderRadius: '8px',
      },
    },
    myPageOrderListItemHead: {
      container: {
        borderRadius: '8px 8px 0 0',
      },
    },
    deliveryLocation: {
      cellButton: {
        borderRadius: '8px',
      },
    },
  },
  customerService: {
    informationEntryGrid: {
      labelBox: {
        backgroundColor: '#FFFAF7',
      },
    },
  },
  termViewForm: {
    textBox: {
      borderRadius: '8px',
    },
  },
  mobile,
};

export const theme = {
  id: 'freet',
  favicon,
  color,
  font,
  image,
  component,
};

export default theme;
